import React, { useContext } from 'react';
import { StoreContext } from 'store';
import { FollowUs } from '../FollowUs';
import { MarketBanner } from '../Banners/MainMarketBanner';
import { Text } from 'components/Text';
import { formatImageUrl } from '../../helpers';
import './footer.scss';

const LINKS = [
  {
    name: 'app-store',
    img: formatImageUrl('/img/app-store.svg'),
    url: 'https://tacticool.onelink.me/jIkU/AS',
  },
  {
    name: 'google-play',
    img: formatImageUrl('/img/google-play.svg'),
    url: 'https://tacticool.onelink.me/jIkU/GP',
  },
  {
    name: 'pc-store',
    img: formatImageUrl('/img/pc-store.svg'),
    url: 'https://tacticool.onelink.me/jIkU/PC',
  },
];

interface FooterProps {
  page: 'main' | 'market' | 'tactistats' | 'quiz';
}

export const Footer: React.FC<FooterProps> = ({ page }) => {
  const { translation: t } = useContext(StoreContext);

  const links = LINKS.map(({ name, img, url }) => {
    return (
      <a key={name} href={url}>
        <img src={img} alt={name} />
      </a>
    );
  });

  return (
    <footer className="c-footer">
      <div className="container">
        <img
          src={formatImageUrl('/img/logo.svg')}
          alt="tacticool"
          className="c-footer__logo"
        />
        <div className="c-footer__learn-more">
          {t.footer.learnMore + ' '}
          <a href="https://tacticool.game/" target="_blank" rel="noreferrer">
            Tacticool game
          </a>
        </div>
        <div id="download-links" className="c-footer__links">
          {links}
        </div>
        <FollowUs />
        <CopyRights />
        <DocumentsLinks page={page} />
      </div>
    </footer>
  );
};

const CopyRights: React.FC = () => {
  return (
    <div className="c-footer__copyrights">
      <div className="c-footer__copyright">
        <img
          src={formatImageUrl('/img/my-games-logo.webp')}
          alt="tacticool"
          className="c-footer__copyright-logo"
        />
        <Text.ParagraphM hasMobileSize={false} className="c-footer__copyright-text">
          © 2024 MY.GAMES B.V. All rights reserved. All trademarks are the property of
          their respective owners. <br />
          MY.GAMES B.V. is registered at De Entree 256, 1101 EE, Amsterdam,
          Netherlands
        </Text.ParagraphM>
      </div>
      <div className="c-footer__copyright">
        <img
          src={formatImageUrl('/img/panzerdog_logo.webp')}
          alt="tacticool"
          className="c-footer__copyright-logo"
        />
        <Text.ParagraphM hasMobileSize={false} className="c-footer__copyright-text">
          © 2023 Panzerdog, Panzedog OY, Tacticool, and any associated logos are
          trademarks, service marks, and/or registered trademarks of Panzedog OY.
        </Text.ParagraphM>
      </div>
    </div>
  );
};

const DocumentsLinks: React.FC<FooterProps> = ({ page }) => (
  <div className="c-footer__documents">
    <a
      href={
        page === 'market'
          ? 'https://documentation.my.games/terms/mygames_privacy '
          : 'https://tacticool.game/privacy'
      }
      target="_blank"
      rel="noreferrer"
    >
      <Text.ParagraphXl className="c-footer__document-title">
        Privacy Policy
      </Text.ParagraphXl>
    </a>
    <a href="https://tacticool.game/cookies" target="_blank" rel="noreferrer">
      <Text.ParagraphXl className="c-footer__document-title">
        Cookies Policy
      </Text.ParagraphXl>
    </a>
    <a
      href="https://documentation.my.games/terms/mygames_tou"
      target="_blank"
      rel="noreferrer"
    >
      <Text.ParagraphXl className="c-footer__document-title">
        Terms of Use
      </Text.ParagraphXl>
    </a>
  </div>
);
